export default __webpack_public_path__ + "static/features-link-icon3.url-efc54ea957cd3e0752a3fad1edde7c08.svg";